
const BooksSvg = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M57.1567 75.6094L17.1882 65.0237L75.5329 49.8633L114.583 60.2222L57.1567 75.6094Z"
        stroke="#0085FF"
        strokeLinejoin="bevel"
      />
      <path
        d="M17.1882 64.5648V69.1588L57.1567 80.1846L114.123 64.5648V59.9707"
        stroke="#0085FF"
      />
      <path
        d="M57.1565 75.5898V80.1839"
        stroke="#0085FF"
        strokeLinejoin="bevel"
      />
      <path
        d="M35.0577 54.4295L8 47.2633L47.498 37L73.9337 44.0127L35.0577 54.4295Z"
        stroke="#0085FF"
        strokeLinejoin="bevel"
      />
      <path
        d="M35.105 54.459V56.2966"
        stroke="#0085FF"
        strokeLinejoin="bevel"
      />
      <path
        d="M8.31079 47.2644V48.8194L35.0575 56.2962L73.6225 45.7093V44.1543"
        stroke="#0085FF"
      />
      <path
        d="M80.4483 93.8488L52.103 86.3415L93.4806 75.5898L121.174 82.9363L80.4483 93.8488Z"
        stroke="#0085FF"
        strokeLinejoin="bevel"
      />
      <path
        d="M52.4287 86.3421V87.9711L80.4482 95.8037L120.848 84.713V83.084"
        stroke="#0085FF"
      />
      <path
        d="M80.5864 93.9668V95.8044"
        stroke="#0085FF"
        strokeLinejoin="bevel"
      />
    </svg>
  );
};

export default BooksSvg;
